module.exports = __webpack_public_path__ + "static/media/img_27.8138b8a2.JPG";